module.exports = __webpack_public_path__ + "img/ASAN_07.f56c7e14.png";